import Icon from "@ant-design/icons";

const SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
  >
    <g id="briefcase" transform="translate(-1 -2)">
      <rect
        id="Rectangle_449"
        data-name="Rectangle 449"
        width="20"
        height="14"
        rx="2"
        transform="translate(2 7)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_1077"
        data-name="Path 1077"
        d="M16,21V5a2,2,0,0,0-2-2H10A2,2,0,0,0,8,5V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

const AntdIcon = (props) => <Icon component={SVG} {...props} />;

export default AntdIcon;
